import React from "react";
import { connect } from "react-redux";
import { BigFilledButton, RightArrowIcon } from "components/Base";
import { actions, getters } from "Portal/CallForPapersForm/model";
import {
  getNextButtonText,
  getNextButtonDisabled,
  getPrimaryButtonColor,
  getPrimaryButtonTextColor
} from "Portal/CallForPapersForm/selectors";
import Tooltip from "ui-kit/Tooltip";
import { noop } from "utils/General";

const decorate = connect(
  state => ({
    text: getNextButtonText(state),
    disabled: getNextButtonDisabled(state),
    saving: getters.saving(state),
    searching: getters.searching(state),
    isClosed: getters.isClosed(state),
    buttonColor: getPrimaryButtonColor(state),
    buttonTextColor: getPrimaryButtonTextColor(state)
  }),
  {
    nextPage: actions.nextPage
  }
);

const NextButton = ({
  disableShowAlert = false,
  handlers = {},
  nextPage = noop,
  text = "",
  disabled = false,
  saving = false,
  searching = false,
  isClosed = false,
  buttonColor,
  buttonTextColor
}) => {
  const ButtonFilled = () => (
    <BigFilledButton
      RightIcon={saving ? undefined : RightArrowIcon}
      style={{
        borderRadius: "20px",
        backgroundColor: buttonColor,
        color: buttonTextColor,
        borderColor: buttonColor
      }}
      onClick={
        saving || searching
          ? noop
          : () => {
              if (disableShowAlert) {
                handlers.setShowAlert(false);
              }
              nextPage();
            }
      }
      disabled={disabled}
    >
      {saving ? "Completing..." : text}
    </BigFilledButton>
  );

  // if saving, just return the button without tooltip
  if (saving) {
    return <ButtonFilled />;
  }

  return isClosed ? (
    <Tooltip
      tooltip={
        disabled && text === "Complete"
          ? "Closed forms cannot be edited. Please contact your event administrator to request changes."
          : null
      }
    >
      <ButtonFilled />
    </Tooltip>
  ) : (
    <Tooltip
      tooltip={
        disabled && text === "Complete"
          ? "Mandatory fields for all speakers must be filled out before completing form."
          : null
      }
    >
      <ButtonFilled />
    </Tooltip>
  );
};

export default decorate(NextButton);
